export const environment = {
  production: true,
  api: 'https://devservices.sequation.net',
  enableCtrl: true,
  azureBlobStorage: 'https://sequationdevsav2.blob.core.windows.net',
  azureCDNStorageUrl: 'https://sequation-dev-v2-cdn.sequation.net',
};
